export enum ViewMode {
    FORM,
    SUMMARY,
    SUBMITTING
}
